var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundWheelProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    "aria-hidden": "true",
    style: {
      display: "block"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 57,
    fill: "#ffffff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.000 4.036 A56 56 0 0 1 98.159 19.013 L88.251 28.921 A42 42 0 0 0 62.000 18.048 Z",
    fill: "#9B5AF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.987 21.841 A56 56 0 0 1 115.964 58.000 L101.952 58.000 A42 42 0 0 0 91.079 31.749 Z",
    fill: "#34D399"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.964 62.000 A56 56 0 0 1 100.987 98.159 L91.079 88.251 A42 42 0 0 0 101.952 62.000 Z",
    fill: "#F59E0B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.159 100.987 A56 56 0 0 1 62.000 115.964 L62.000 101.952 A42 42 0 0 0 88.251 91.079 Z",
    fill: "#F472B6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.000 115.964 A56 56 0 0 1 21.841 100.987 L31.749 91.079 A42 42 0 0 0 58.000 101.952 Z",
    fill: "#22D3EE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.013 98.159 A56 56 0 0 1 4.036 62.000 L18.048 62.000 A42 42 0 0 0 28.921 88.251 Z",
    fill: "#6D5EF6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.036 58.000 A56 56 0 0 1 19.013 21.841 L28.921 31.749 A42 42 0 0 0 18.048 58.000 Z",
    fill: "#9B5AF8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.841 19.013 A56 56 0 0 1 58.000 4.036 L58.000 18.048 A42 42 0 0 0 31.749 28.921 Z",
    fill: "#34D399"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 40.5,
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundWheelProfile);
export default __webpack_public_path__ + "static/media/backgroundWheelProfile.159b6d1dfc37cb0b4eb898fb37db6b4a.svg";
export { ForwardRef as ReactComponent };